import { Chip, useTheme } from '@mui/material';
import React from 'react';
import { EquipmentStatus } from '../../domain/types';

interface Props {
  status: EquipmentStatus | string | null;
  loading?: boolean;
}

// Extract styles to a constant for better maintainability
const chipStyles = { minWidth: 80, fontSize: '0.75rem' };

// Define the valid MUI Chip color types
type ChipColor = 'success' | 'error' | 'warning' | 'default' | 'primary' | 'secondary' | 'info';

export const EquipmentStatusChip: React.FC<Props> = ({ status, loading = false }) => {
  const theme = useTheme();

  const getStatusColor = (status: string): ChipColor => {
    if (!status) return 'default';

    switch (status.toLowerCase()) {
      case 'in service':
        return 'success';
      case 'out of service':
      case 'maintenance':
        return 'error';
      case 'booked':
        return 'info';
      case 'inactive':
        return 'default';
      case 'available':
        return 'success';
      case 'unspecified':
        return 'default';
      default:
        return 'default';
    }
  };

  const getCustomStyles = (status: string) => {
    if (status.toLowerCase() === 'inactive') {
      return {
        ...chipStyles,
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.common.white,
        '&:hover': {
          backgroundColor: theme.palette.grey[700]
        }
      };
    }
    return chipStyles;
  };

  if (loading) {
    return <Chip label="Loading..." color="default" size="small" sx={chipStyles} />;
  }

  if (!status) {
    return <Chip label="Unknown" color="default" size="small" sx={chipStyles} />;
  }

  return <Chip label={status} color={getStatusColor(status)} size="small" sx={getCustomStyles(status)} />;
};
